import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { setPostLoginRedirect } from '../../../actions';

class Protected extends React.Component {
	redirectUrl = '/login';

	constructor(props) {
		super(props);
		this.state = {
			initialized: false,
		};
	}

	componentDidMount = () => {
		this.setState({
			initialized: true,
		});
	}

	isAllowed = () => {
		return !!this.props.auth.access_token;
	}

	render() {
		const { initialized } = this.state;
		const { children } = this.props;
		const allow = this.isAllowed();

		if (!initialized) {
			return null;
		}
		if (allow) {
			return children;
		}

		// Send to Login page!
		this.props.setPostLoginRedirect(this.props.match.url);
		return (
			<Route render={({ staticContext }) => {
				// eslint-disable-next-line
				if (staticContext) staticContext.status = 200;
				return <Redirect to={this.redirectUrl} />;
			}}/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const {user, auth} = state;
	return {
		user,
		auth
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		setPostLoginRedirect: (...args) => dispatch(setPostLoginRedirect(...args)),
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Protected));
